<script>
  import Splash from './Splash.svelte';
  import Container from './Container.svelte';

  export let showEarlyAccessForm;

</script>

<Splash text="Define the validation method &#8594; A&nbsp;freelancer will solve it ASAP" />

<div style="display: flex; position: relative;" id='flex'>
  <div id='hire' class='panel'>
    <Container style='background-color: transparent'>
      <div style="height: 550px;">
        <h2 style='margin-top: 30px'>Get Code for Money</h2>
        <div style='height: 50px'></div>
        <ul>
          <li>Specify inputs-outputs, attributes, methods</li>
          &darr;
          <li>Define validation criteria</li>
          &darr;
          <li>Deposit budget</li>
          <span style='opacity: 50%'>
            &darr;
          </span>
          <span style='opacity: 20%'>
            <li>Do some other work?</li>
            &darr;
            <li>Prepare other tasks?</li>
            &darr;
            <li>Get a coffee?</li>
            &darr;
            <li> Reconnect with the family? Go to the park? Enjoy life?</li>
          </span>
          <span style='opacity: 50%'>
          &darr;
          </span>
          <li><strong>Get solution code</strong></li>
        </ul>
      </div>
      <a href='/new_task' class='pure-button white' style='border-color: var(--secondary-color); color: var(--secondary-color);' >Try Create a Demo Task</a>
      <div style='height: calc(70vh - 650px)'></div>
    </Container>
  </div>

  <div id='work' class='panel'>
    <Container style='background-color: transparent'>
      <div style="height: 550px">
        <h2 style='margin-top: 30px'>Get Money for Code</h2>
        <div style='height: 50px'></div>
        <ul class='transparent-gradient'>
          <li>Pass the validation criteria</li>
          &darr;
          <li>Get paid</li>
          &darr;
          <li>Client gets access to code</li>
          &darr;
        </ul>
        <ul style='margin-top: 3px;'>
          <li>Pick a task to work on</li>
          &darr;
          <li>Be the only one working on the task for a limited time</li>
          &darr;
          <li>Pass the validation criteria</li>
          &darr;
          <li><strong>Get paid</strong></li>
          &darr;
          <li>Code is sent to client</li>
        </ul>
      </div>
      <a href='/freelancer' class='pure-button white' style='border-color: var(--tertiary-color); color: var(--tertiary-color);'>Try Solve Demo Tasks</a>
      <div style='height: 150px;'></div>
      <div style='height: calc(70vh - 800px)'></div>
    </Container>
  </div>
  <button id='request' class='pure-button-primary pure-button'
    on:click={showEarlyAccessForm}>Are you interested?</button>
</div>
<!-- <div>
  <Container style='background-color: #f5f5f5'>
    <h2>Validation Methods</h2>

    <p>
      Clients on Interviewless will have an array of options of how the submitted test will be validated, each with different trade-offs and applicable situations. Additionally, these methods can be used in conjunction, for example, a task can start off as a simple IO set task and then escalate to convergent submissions or peer reviewed if the client reports misconduct.
    </p>
    <ul>
      <li>
        Set of expected input-outputs

        The client defines a set of input-output pairs, some of which the freelancer will see, others not. This method is suitable for simpler functions and clients that can spend the upfront time to define the input-output pairs.
      </li>
      <li>
        Test Function

        This option gives the client flexibility to generate more complex or interesting tests, like 
      </li>
      <li>
        Convergent Submissions
      </li>
      <li>
        Peer Review
      </li>
    </ul>
  </Container>
</div> -->

<style>
  .panel {
    width: 100%;
    color: var(--background);
    background-color: var(--background);
    transition: 0.2s;
  }
  #hire {
    color: var(--secondary-color);
  }
  #hire:hover {
    background-color: var(--secondary-color);
    color: var(--background);
  }
  #work {
    position: relative;
    color: var(--tertiary-color);
  }
  #work:hover {
    background-color: var(--tertiary-color);
    color: var(--background);
  }
  ul {
    padding-left: 0;
    list-style: none;
    font-size: 18px;
  }
  .transparent-gradient {
   opacity: .2;
   margin-bottom: 0;
  }
  .white {
    background-color: var(--background);
    border-style: solid;
    border-width: 1px;
    color: var(--foreground);
    margin-bottom: 50px;
  }
  #request {
    background-color: var(--background);
    color: var(--primary-color);
    bottom: 50%; 
    left: 50%;
    white-space: normal;
    width: 150px;
    height: 150px;
    border-radius: 75px;
    transform: translateX(-50%);
    position: absolute;
  }
  #request:hover {
    background-color: var(--primary-color);
    color: var(--background);
  }
  @media (max-width: 800px){
    #flex {
      flex-direction: column;
    }
  }
  @media (max-width: 1200px){
    #request {
      bottom: 30px;
    }
  }
</style>